export default __webpack_public_path__ + "static/media/top-bright-circle.640def93.png";